<jhi-modal title="{{ 'study-editor.import-design.import-file.title' | translate }}" [disabled]="isSaving">
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span class="fw-bold">{{ 'study-editor.import-design.import-file.heading' | translate | uppercase}}</span></div>
        </div>
        <div class="row pt-2">
            <div class="col">
                <span>{{ 'study-editor.import-design.import-file.description' | translate}}</span>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col">
                <span class="fw-bold">{{ 'study-editor.import-design.import-file.specify-file-description' | translate}}</span>
            </div>
            <div class="col">
                <ng-select [items]="importFormats" [(ngModel)]="selectedFormat" bindLabel="name" placeholder="{{'study-editor.study-dataset.export-study-modal.select-format' | translate}}" [clearable]="false" required>
                </ng-select>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col"></div>
            <div class="col">
				<jhi-file-select id="file"
								 [acceptedFileTypes]="selectedFormat?.extension"
								 (fileSelected)="handleFileChange($event)"
								 (fileCleared)="clearSelectedFile()">
				</jhi-file-select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
            <span translate="cancel"></span>
        </button>
        <button (click)="submitImport()" class="btn btn-primary" [disabled]="isSaving || !importedData">
            <span *ngIf="isSaving" class="throbber throbber-btn"></span>
            <span translate="continue"></span>
        </button>
    </div>
</jhi-modal>
